import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';

export const authCodeFlowConfig: AuthConfig = {
  issuer: environment.oAuthIssuerUrl,
  redirectUri: window.location.origin,
  // oidc: false,
  useSilentRefresh: true,
  silentRefreshRedirectUri: window.location.origin + '/silent-refresh.html',

  clientId: environment.clientId,
  responseType: 'code',

  scope: environment.scope,

  showDebugInformation: !environment.production,
  requireHttps: false,
  // if there will be a need to display custom logout page in the client, uncomment this code:
  // postLogoutRedirectUri: window.location.origin + '/logout',
  // logoutUrl: window.location.origin + '/logout',
};

export class Claims {
  public name!: string;
  public sub!: string;
}
